import { Link } from '@ps/web-shared-components';
import React from 'react';

import type { EventTypeDynamicBanner, ImageFetchProps } from '../../model/types';
import BannerImage from '../BannerImage/BannerImage';

import styles from './BasicBanner.scss';

const EventTypeBanner: React.FC<EventTypeDynamicBanner & ImageFetchProps> = ({
  eventType,
  image,
  priority
}) => (
  <Link className={styles.container} alias="sportsSport" values={{ ...eventType }}>
    <BannerImage image={image} priority={priority} />
    <h2>{eventType.eventTypeName}</h2>
  </Link>
);

export default EventTypeBanner;
